import { useState } from 'react';
import { applyTheme, readStoredTheme, THEME_HINT, THEME_LABEL, type ThemePref } from '@antreja/ui/theme';
import { useAuth } from '../auth/AuthProvider';
import { useServices } from '../app/services';
import { useToast } from './ui';

const ORDER: ThemePref[] = ['system', 'light', 'dark'];

/** Systeem / Licht / Donker (brandbook v2 p. 57). Direct toegepast; bewaard bij het account. */
export function ThemeSwitch({ onDark = false }: { onDark?: boolean }) {
  const { session } = useAuth();
  const { repo } = useServices();
  const toast = useToast();
  const [pref, setPref] = useState<ThemePref>(() => readStoredTheme());
  const choose = async (p: ThemePref) => {
    setPref(p);
    applyTheme(p);
    if (!session) return;
    try {
      await repo.setMyTheme(session.profile.id, p);
    } catch {
      toast('Weergave aangepast op dit apparaat; opslaan bij je account lukte niet.');
    }
  };
  return (
    <div className={`theme-switch ${onDark ? 'on-dark' : ''}`} role="radiogroup" aria-label="Weergave">
      {ORDER.map((p) => (
        <button key={p} type="button" role="radio" aria-checked={pref === p} title={THEME_HINT[p]} onClick={() => void choose(p)}>
          {THEME_LABEL[p]}
        </button>
      ))}
    </div>
  );
}
